"use client";

import { Search } from "lucide-react";
import { Input } from "../../../ui/input";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@/components/ui/popover";
import React, { useState } from "react";
import { useLocale, useTranslations } from "next-intl";
import { Button } from "../../../ui/button";
import { CategoryModel } from "@/types/category";
import { PopularSearchModel } from "@/types/search";
import { cn } from "@/lib/utils";
import SearchContent from "./search-content";

interface Props {
  popularCategories: CategoryModel[];
  popularSearch: PopularSearchModel[];
  customerSearch: PopularSearchModel[] | null;
}

const SearchPopover = ({
  popularCategories,
  popularSearch,
  customerSearch,
}: Props) => {
  const t = useTranslations();
  const locale = useLocale();

  const [open, setOpen] = useState(false);

  return (
    <>
      {open && (
        <div
          onClick={() => setOpen(false)}
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"
        />
      )}

      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <div className="relative ">
            <Input
              placeholder={t("searchProduct")}
              className="bg-gray-100 shadow-none w-xs lg:w-md cursor-pointer"
              readOnly
            />
            <Button
              size="icon"
              variant="link"
              className={cn("absolute  rounded-tr-none rounded-br-none", {
                "left-1": locale === "ar",
                "right-1": locale === "en",
              })}
            >
              <Search />
            </Button>
          </div>
        </PopoverTrigger>

        <PopoverContent
          align="center"
          sideOffset={20}
          className="z-50 w-[380px] lg:w-[500px] overflow-y-auto p-6 mt-4 bg-white rounded-xl shadow-lg"
        >
          <SearchContent
            popularCategories={popularCategories}
            popularSearch={popularSearch}
            customerSearch={customerSearch}
            setOpen={setOpen}
          />
        </PopoverContent>
      </Popover>
    </>
  );
};

export default SearchPopover;
